import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  Message,
  MessageRecipientInfo,
  MessageSenderInfo,
  MessageState,
} from '../../../models/profile-messages.model';
import { ScrollToBottomDirective } from '../../../../../scrollbar/scroll-to-bottom.directive';
import { ScrollbarModule } from '../../../../../scrollbar/scrollbar.module';
import { AccountStatusComponent } from '../../../../user/accounts/components/account-status/account-status.component';

@Component({
  selector: 'app-messages-container',
  templateUrl: './messages-container.component.html',
  styleUrls: ['./messages-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    TranslateModule,
    ScrollToBottomDirective,
    ScrollbarModule,
    AccountStatusComponent,
  ],
})
export class MessagesContainerComponent {
  @Input() senders: MessageSenderInfo[] = [];
  @Input() recipientInfo: MessageRecipientInfo | null = null;
  @Input() messages: Message[] = [];
  @Input() messageState: MessageState = 'loading';
  @Input() isProfileConnecting: boolean = false;

  private _selectedSenderId: string | null = null;
  private isInitializing = true;

  @Input()
  set selectedSenderId(value: string | null) {
    this._selectedSenderId = value;

    if (value && this.isInitializing) {
      this.isInitializing = false;
      this.loadSenderMessages();
    }
  }

  get selectedSenderId(): string | null {
    return this._selectedSenderId;
  }

  @Output() onSenderSelect = new EventEmitter<MessageSenderInfo>();
  @Output() onSendMessage = new EventEmitter<string>();
  @Output() onConnectProfile = new EventEmitter<void>();

  messageText = '';

  selectSender(sender: MessageSenderInfo): void {
    this.onSenderSelect.emit(sender);
  }

  sendMessage(): void {
    if (this.messageText.trim()) {
      this.onSendMessage.emit(this.messageText);
      this.messageText = '';
    }
  }

  connectProfile(): void {
    if (!this.isProfileConnecting) {
      this.onConnectProfile.emit();
    }
  }

  private loadSenderMessages(): void {
    if (this._selectedSenderId && this.senders.length > 0) {
      const selectedSender = this.senders.find((sender) => sender.id === this._selectedSenderId);
      if (selectedSender) {
        this.onSenderSelect.emit(selectedSender);
      }
    }
  }
}
